import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "../Modal";
import {
  getAllSkuOriginList,
  getSkuBrands,
  getSkuNames,
  requestNewSku,
} from "../../../../services/sku";
import { errorToast, successToast } from "../../../../helpers/toast";
import Ripple from "../../spinners/ripple/Ripple";
import Select from "../../../Select/Select";
import CarSelection from "./CarSelection";

const RequestNewSkuModal = ({
  closeModal,
  initialSkuName,
  initialSkuNameId,
}) => {
  const selectedMechanic = useSelector((state) => state.mechanic);
  const salesAgent = useSelector((state) => state.auth);
  const { voiceOrderId } = useSelector((state) => state.order);
  const { selectedCar: selectedCarFromDropdowns } = useSelector(
    (state) => state.car
  );

  const [selectedCar, setSelectedCar] = useState(selectedCarFromDropdowns);
  const [skuBrandsLoading, setSkuBrandsLoading] = useState(false);
  const [skuOriginsLoading, setSkuOriginsLoading] = useState(false);
  const [skuBrands, setSkuBrands] = useState([]);
  const [skuOrigins, setSkuOrigins] = useState([]);
  const [skuNamesLoading, setSkuNamesLoading] = useState(false);
  const [skuNames, setSkuNames] = useState([]);
  const [selectedSkuBrand, setSelectedSkuBrand] = useState();
  const [selectedSkuOrigin, setSelectedSkuOrigin] = useState();
  const [selectedSkuNames, setSelectedSkuNames] = useState(
    initialSkuName ? [initialSkuName] : []
  );
  const [specificationComment, setSpecificationComment] = useState("");
  const [requestNewSkuLoading, setRequestNewSkuLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState();
  const didInitSelectedCarRef = useRef(false);
  const didInitSkuNameRef = useRef(false);

  useEffect(() => {
    if (didInitSkuNameRef.current) return;
    if (!initialSkuName) return;

    setSelectedSkuNames([initialSkuName]);
    didInitSkuNameRef.current = true;
  }, [initialSkuName]);

  useEffect(() => {
    if (didInitSkuNameRef.current) return;
    if (!initialSkuNameId) return;
    if (!skuNames?.length) return;

    const matchedSkuName = skuNames.find(({ id }) => id === initialSkuNameId);
    if (!matchedSkuName) return;

    setSelectedSkuNames([matchedSkuName]);
    didInitSkuNameRef.current = true;
  }, [initialSkuNameId, skuNames]);

  useEffect(() => {
    if (didInitSelectedCarRef.current) return;
    if (selectedCar) {
      didInitSelectedCarRef.current = true;
      return;
    }
    if (!selectedCarFromDropdowns) return;

    setSelectedCar(selectedCarFromDropdowns);
    didInitSelectedCarRef.current = true;
  }, [selectedCar, selectedCarFromDropdowns]);

  const onSubmit = async (e) => {
    e.preventDefault();

    setRequestNewSkuLoading(true);

    const formData = {
      mechanicId: selectedMechanic.id,
      salesAgentId: salesAgent.id,
      carId: selectedCar?.carDetails?.id,
      quantity,
      price: price === "" || price === undefined ? undefined : Number(price),
      skuBrandId: selectedSkuBrand?.id,
      skuNameIdList: selectedSkuNames.map(({ id }) => id),
      skuOriginId: selectedSkuOrigin?.id,
      comment: specificationComment,
      carBrandId: selectedCar?.brand?.id,
      carModelId: selectedCar?.model?.id,
      carStartYear: selectedCar?.year?.startYear,
      carEndYear: selectedCar?.year?.endYear,
      cc: selectedCar?.carDetails?.cc,
      transmission: selectedCar?.carDetails?.transmission,
      voiceOrderId,
    };

    try {
      await requestNewSku(formData);

      successToast("تم اضافه طلبك بنجاح");
      closeModal();
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error;

      errorToast(message);
      console.log(error);
    }

    setRequestNewSkuLoading(false);
  };

  useEffect(() => {
    const fetchSkuBrands = async () => {
      setSkuBrandsLoading(true);
      try {
        const response = await getSkuBrands();
        setSkuBrands(response.data.data);
      } catch (error) {
        console.log(error);
      }
      setSkuBrandsLoading(false);
    };

    fetchSkuBrands();
  }, []);

  useEffect(() => {
    const fetchSkuOrigins = async () => {
      setSkuOriginsLoading(true);
      try {
        const response = await getAllSkuOriginList();
        setSkuOrigins(response.data.originSkuList);
      } catch (error) {
        console.log(error);
      }
      setSkuOriginsLoading(false);
    };

    fetchSkuOrigins();
  }, []);

  useEffect(() => {
    const fetchSkuNames = async () => {
      setSkuNamesLoading(true);
      try {
        const response = await getSkuNames();
        setSkuNames(response.data.data);
      } catch (error) {
        console.log(error);
      }
      setSkuNamesLoading(false);
    };

    fetchSkuNames();
  }, []);

  const skuBrandSelectedHandler = (skuBrand) => {
    setSelectedSkuBrand(skuBrand);
  };

  const skuOriginSelectedHandler = (skuOrigin) => {
    setSelectedSkuOrigin(skuOrigin);
  };

  const skuNamesMultiSelectedHandler = (selectedSkuNameOptions) => {
    setSelectedSkuNames(selectedSkuNameOptions);
  };

  const specificationCommentChangedHandler = (event) => {
    const { value } = event.target;
    setSpecificationComment(value);
  };

  const content = () => {
    if (!selectedMechanic) {
      return (
        <p className="mt-0 text-xs font-bold text-red-500">
          Should Select Mechanic first
        </p>
      );
    } else if (skuBrandsLoading || skuOriginsLoading || skuNamesLoading) {
      return <Ripple className="border-dark-blue" />;
    } else {
      return (
        <div className="w-full flex flex-col">
          <div className="mb-4">
            <label className="mb-2"> Sku Name </label>
            <Select
              placeholder="ابحث بالاسم"
              options={skuNames}
              optionLabelProp="skuName"
              onSelect={skuNamesMultiSelectedHandler}
              initialValue={selectedSkuNames}
              isMulti
            />
          </div>

          <div className="flex gap-6 mb-4">
            <div className="w-1/2">
              <label className="mb-2"> اسم البراند </label>
              <Select
                placeholder="ابحث بالاسم"
                options={skuBrands}
                optionLabelProp="brandName"
                onSelect={skuBrandSelectedHandler}
                initialValue={selectedSkuBrand?.brandName}
              />
            </div>

            <div className="w-1/2">
              <label className="mb-2"> المنشأ </label>
              <Select
                placeholder="ابحث بالاسم"
                options={skuOrigins}
                optionLabelProp="originName"
                onSelect={skuOriginSelectedHandler}
                initialValue={selectedSkuOrigin?.originName}
              />
            </div>
          </div>

          <CarSelection
            selectedCar={selectedCar}
            setSelectedCar={setSelectedCar}
          />

          <div className="flex gap-6 mb-4">
            <div className="w-1/2">
              <label htmlFor="price">سعر البيع</label>
              <input
                id="price"
                type="number"
                placeholder="من فضلك اضف سعر السوق"
                value={price}
                min={0}
                onChange={(e) => setPrice(e.target.value)}
                className="block w-full border border-light-gray mt-2 p-2 focus:border-dark-blue rounded"
              />
            </div>

            <div className="w-1/2 ">
              <label htmlFor="quantity">الكمية المطلوبة</label>
              <input
                id="quantity"
                type="number"
                min={1}
                placeholder="الكمية"
                value={quantity}
                onChange={(e) => {
                  const { value } = e.target;
                  setQuantity(value === "" ? 1 : parseInt(value, 10));
                }}
                className="block w-full border border-light-gray mt-2 p-2 focus:border-dark-blue rounded"
              />
            </div>
          </div>

          <div>
            <label htmlFor="specificationComment">ملاحظات خاصة</label>
            <textarea
              id="specificationComment"
              rows={4}
              value={specificationComment}
              onChange={specificationCommentChangedHandler}
              className="p-2 border border-#DFDFDF rounded w-full text-right"
            />
          </div>

          <div className="flex justify-between items-center gap-2 mt-4">
            <button
              type="submit"
              className="bg-dark-blue text-white p-2 rounded-lg w-1/2"
              disabled={
                !selectedMechanic ||
                !selectedCar?.carDetails ||
                requestNewSkuLoading
              }
            >
              إضافة
            </button>

            <button
              type="button"
              className="bg-gray-300 text-gray-700 p-2 rounded-lg w-1/2"
              onClick={closeModal}
            >
              إلغاء
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <Modal close={closeModal} classNames="lg:w-2/3 sm:w-2/3 top-4">
      <form
        dir="rtl"
        autoComplete="off"
        className="flex flex-col items-center gap-7 w-full"
        onSubmit={onSubmit}
      >
        <div>
          <h3>اضافه منتج الي قائمة المنتجات المطلوبة</h3>

          {voiceOrderId && (
            <p className="text-center text-lg font-bold text-pink-900 mt-4">
              Voice Order ID: {voiceOrderId}
            </p>
          )}
        </div>

        {content()}
      </form>
    </Modal>
  );
};

export default RequestNewSkuModal;
